/**
 * @module experience/landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
// Core Libraries
import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
// model
import { LinePendingOrdersModel } from '@experience/landing/common/models/line-pending-orders.model';
import { PendingOrdersService } from '@experience/change-plan-services/services/pending-orders.service';
import { APP_ROUTE_CONSTANTS } from '@root/shared/constants/app-route.constants';
// services
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';

@Component({
  selector: 'tmo-line-pending-orders',
  templateUrl: './line-pending-orders.component.html',
})
export class LinePendingOrdersComponent implements OnInit, OnDestroy {
  /*
   * AEM content data
   */
  @Input() public contentData: ConfigData;
  /*
   * line pending orders model to filter orders based on type
   */
  @Input() public linePendingOrdersModel: LinePendingOrdersModel;

  /**
   * Unsubscriber for all subscribtions
   */
  private ngUnsubscribe: Subject<void>;

  constructor(
    public router: Router,
    public pendingOrdersService: PendingOrdersService,
    private stateStoreUtilsService: StateStoreUtilsService
  ) {
    this.ngUnsubscribe = new Subject<void>();
  }

  /**
   * Loads the initial data of line pending orders Page
   * @returns void
   */
  public ngOnInit(): void {}

  /**
   * Unsubscribes for all subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Method to go to a particular order summary
   * @param orderIdSelected Order Id of the clicked order
   */
  public goToOrderSummary(orderIdSelected: string): void {
    this.stateStoreUtilsService.setCustomerOrderId(orderIdSelected);
    this.router.navigate([APP_ROUTE_CONSTANTS.ORDER_SUMMARY_URL]);
  }
}
